var _rect, _circle, _g, _rect2, _rect3, _circle2, _g2, _rect4, _rect5, _circle3, _g3, _rect6, _rect7, _circle4, _g4, _rect8, _rect9, _circle5, _g5, _rect0, _rect1, _circle6, _g6, _rect10, _rect11, _circle7, _g7, _rect12, _path, _circle8, _circle9, _path2, _path3, _path4, _circle0, _circle1, _circle10, _circle11, _rect13, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveHobbyDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 151,
    viewBox: "0 0 264 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9758)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.6807,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(8 89.6807 0)",
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11322_9758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 3,
    width: 49,
    height: 49
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110.107,
    cy: 27.1066,
    r: 24,
    transform: "rotate(8 110.107 27.1066)",
    fill: "#CCCCCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11322_9758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3883 62.7307C89.6846 70.0429 75.8906 68.1043 68.5784 58.4006C61.2662 48.697 63.2048 34.9029 72.9084 27.5907C82.6121 20.2785 96.4061 22.2171 103.718 31.9208C111.031 41.6244 109.092 55.4185 99.3883 62.7307Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.306 26.6201C137.603 33.9323 123.809 31.9937 116.496 22.2901C109.184 12.5864 111.123 -1.20764 120.826 -8.51985C130.53 -15.8321 144.324 -13.8934 151.636 -4.1898C158.949 5.51383 157.01 19.3079 147.306 26.6201Z",
    fill: "#F7F9ED"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8296,
    y: -1.12944,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 88.8296 -1.12944)",
    stroke: "#121B3E",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9758)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-0.987688 0.156434 0.156434 0.987688 196.409 10)",
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11322_9758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 13,
    width: 49,
    height: 49
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "matrix(-0.987688 0.156434 0.156434 0.987688 196.409 10)",
    fill: "#CCCCCC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11322_9758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.798 72.8904C197.628 80.0321 211.386 77.8531 218.528 68.0233C225.67 58.1935 223.491 44.4354 213.661 37.2936C203.831 30.1519 190.073 32.331 182.931 42.1607C175.789 51.9905 177.968 65.7486 187.798 72.8904Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.257 37.6216C149.087 44.7634 162.845 42.5843 169.987 32.7545C177.129 22.9247 174.95 9.1666 165.12 2.02486C155.29 -5.11689 141.532 -2.93781 134.39 6.89196C127.248 16.7217 129.427 30.4799 139.257 37.6216Z",
    fill: "#F7F9ED"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.831254,
    y: -1.14412,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.987688 0.156434 0.156434 0.987688 198.24 9.85588)",
    stroke: "#121B3E",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9758)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 37.9307,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-3 44 37.9307)",
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11322_9758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 36,
    width: 57,
    height: 57
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.427,
    cy: 64.4269,
    r: 28,
    transform: "rotate(-3 73.427 64.4269)",
    fill: "#CCCCCC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11322_9758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0818 107.611C59.5967 118.145 43.3677 118.996 32.8334 109.511C22.2991 100.025 21.4486 83.7965 30.9337 73.2622C40.4188 62.7279 56.6478 61.8774 67.1821 71.3625C77.7164 80.8476 78.5669 97.0766 69.0818 107.611Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.921 55.5889C106.435 66.1232 90.2064 66.9737 79.6721 57.4886C69.1378 48.0034 68.2873 31.7745 77.7724 21.2402C87.2575 10.7059 103.486 9.85534 114.021 19.3405C124.555 28.8256 125.406 45.0546 115.921 55.5889Z",
    fill: "#F7F9ED"
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42.949,
    y: 36.9844,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 42.949 36.9844)",
    stroke: "#121B3E",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11322_9758)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 78.9062,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-4 76 78.9062)",
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11322_9758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 76,
    width: 57,
    height: 57
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.885,
    cy: 104.885,
    r: 28,
    transform: "rotate(-4 105.885 104.885)",
    fill: "#CCCCCC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11322_9758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.295 148.138C92.9947 158.836 76.783 159.97 66.0848 150.67C55.3865 141.37 54.2529 125.158 63.5528 114.46C72.8526 103.762 89.0642 102.628 99.7625 111.928C110.461 121.228 111.594 137.44 102.295 148.138Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.218 95.3063C138.918 106.005 122.707 107.138 112.008 97.8383C101.31 88.5385 100.177 72.3268 109.476 61.6286C118.776 50.9303 134.988 49.7967 145.686 59.0965C156.384 68.3964 157.518 84.608 148.218 95.3063Z",
    fill: "#F7F9ED"
  })))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9327,
    y: 77.9784,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 74.9327 77.9784)",
    stroke: "#121B3E",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11322_9758)"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 113.906,
    y: 35,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(4 113.906 35)",
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11322_9758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 36,
    width: 57,
    height: 57
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.885,
    cy: 64.885,
    r: 28,
    transform: "rotate(4 139.885 64.885)",
    fill: "#CCCCCC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11322_9758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.309 107.217C119.611 116.517 103.399 115.384 94.0993 104.685C84.7995 93.9872 85.9331 77.7756 96.6314 68.4757C107.33 59.1759 123.541 60.3095 132.841 71.0078C142.141 81.706 141.007 97.9177 130.309 107.217Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.138 61.2914C172.44 70.5913 156.229 69.4576 146.929 58.7594C137.629 48.0612 138.763 31.8495 149.461 22.5497C160.159 13.2498 176.371 14.3835 185.671 25.0817C194.97 35.7799 193.837 51.9916 183.138 61.2914Z",
    fill: "#F7F9ED"
  })))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 112.978,
    y: 33.9327,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 112.978 33.9327)",
    stroke: "#121B3E",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_11322_9758)"
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 163.681,
    y: 54,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(8 163.681 54)",
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11322_9758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 160,
    y: 57,
    width: 49,
    height: 49
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.107,
    cy: 81.1066,
    r: 24,
    transform: "rotate(8 184.107 81.1066)",
    fill: "#CCCCCC"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11322_9758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.388 116.731C163.685 124.043 149.891 122.104 142.578 112.401C135.266 102.697 137.205 88.9029 146.908 81.5907C156.612 74.2785 170.406 76.2171 177.718 85.9208C185.031 95.6244 183.092 109.418 173.388 116.731Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.306 80.6201C211.603 87.9323 197.809 85.9937 190.496 76.2901C183.184 66.5864 185.123 52.7924 194.826 45.4801C204.53 38.1679 218.324 40.1066 225.636 49.8102C232.949 59.5138 231.01 73.3079 221.306 80.6201Z",
    fill: "#F7F9ED"
  })))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 162.83,
    y: 52.8706,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 162.83 52.8706)",
    stroke: "#121B3E",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_11322_9758)"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 173.817 84)",
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11322_9758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 85,
    width: 50,
    height: 50
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 173.817 84)",
    fill: "#CCCCCC"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11322_9758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.84 146.137C170.148 153.947 184.024 152.733 191.834 143.425C199.644 134.118 198.43 120.241 189.123 112.431C179.815 104.621 165.938 105.835 158.128 115.143C150.318 124.45 151.532 138.327 160.84 146.137Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.877 107.568C124.185 115.378 138.062 114.164 145.872 104.856C153.682 95.5487 152.468 81.672 143.16 73.862C133.852 66.052 119.976 67.266 112.166 76.5737C104.356 85.8813 105.57 99.7579 114.877 107.568Z",
    fill: "#F7F9ED"
  })))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 0.909039,
    y: -1.08335,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 175.726 83.9166)",
    stroke: "#121B3E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 93C60 91.8954 60.8954 91 62 91H82.2654C83.2607 91 84.1046 91.7319 84.2453 92.7172L87.7547 117.283C87.8954 118.268 88.7393 119 89.7346 119H190.265C191.261 119 192.105 118.268 192.245 117.283L195.755 92.7172C195.895 91.7319 196.739 91 197.735 91H218C219.105 91 220 91.8954 220 93V119V145C220 146.105 219.105 147 218 147H188H92H62C60.8954 147 60 146.105 60 145V119V93Z",
    fill: "#263367"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 125.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 36.5,
    r: 1.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 85L10 91.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5 29L236.5 23",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.5 78L249.5 80.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.5,
    cy: 43.5,
    r: 1.5,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.5,
    cy: 119.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 32 151)",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 16.5L55 22.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9758"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.6807,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(8 89.6807 0)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-0.987688 0.156434 0.156434 0.987688 196.409 10)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9758"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 37.9307,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-3 44 37.9307)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11322_9758"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 78.9062,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-4 76 78.9062)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11322_9758"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.906,
    y: 35,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(4 113.906 35)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_11322_9758"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.681,
    y: 54,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(8 163.681 54)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_11322_9758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 173.817 84)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveHobbyDevelopment);
export default __webpack_public_path__ + "static/media/collective-hobby-development.d6d86508495e844882c794e87194be98.svg";
export { ForwardRef as ReactComponent };